/* JOGRIX: gentle reveal on scroll, the word-by-word statement and the app
   showcase. Everything is visible without this script; it only adds motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var root = document.documentElement;
  if (!("IntersectionObserver" in window)) return;
  root.classList.add("jx-motion");

  // Fade and lift as things come into view.
  var reveal = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); reveal.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -10% 0px" });
  document.querySelectorAll("[data-reveal]").forEach(function (el) { reveal.observe(el); });

  // Large statement: words brighten as you scroll through it.
  document.querySelectorAll("[data-words]").forEach(function (el) {
    if (reduce) return;
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute("aria-label", el.textContent.trim());
    el.innerHTML = words.map(function (w) { return '<span aria-hidden="true">' + w.replace(/[&<>]/g, "") + "</span>"; }).join(" ");
    var spans = el.querySelectorAll("span");
    function paint() {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var lit = Math.round(p * spans.length);
      spans.forEach(function (s, i) { s.classList.toggle("is-lit", i < lit); });
    }
    paint();
    window.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint);
  });

  // Pinned statement: the section holds still while each line rises into view
  // and brightens to white, then the page scrolls on as normal.
  document.querySelectorAll("[data-pin-lines]").forEach(function (sec) {
    var el = sec.querySelector("[data-lines]");
    var stage = sec.querySelector(".jxh-pin__stage");
    if (!el || !stage || reduce) return;
    var text = el.textContent.trim();
    var words = text.split(/\s+/);
    var lines = [], inner = [], fallback = false;
    el.setAttribute("aria-label", text);
    sec.classList.add("is-pinned");

    function build() {
      el.innerHTML = words.map(function (w) { return '<span class="jxh-w" aria-hidden="true">' + w.replace(/[&<>]/g, "") + "</span>"; }).join(" ");
      var ws = el.querySelectorAll(".jxh-w"), groups = [], top = null;
      ws.forEach(function (w) {
        var t = w.offsetTop;
        if (top === null || Math.abs(t - top) > 4) { groups.push([]); top = t; }
        groups[groups.length - 1].push(w.textContent);
      });
      el.innerHTML = groups.map(function (g) {
        return '<span class="jxh-line" aria-hidden="true"><span class="jxh-line__in">' + g.join(" ") + "</span></span>";
      }).join("");
      inner = Array.prototype.slice.call(el.querySelectorAll(".jxh-line__in"));
      lines = groups;
      size();
    }

    // Hold the words around the middle of the screen, and give each line a
    // short stretch of scrolling. The section is no taller than it needs to be.
    var stageH = 0, pinTop = 0;
    function size() {
      var vh = window.innerHeight || 1;
      stageH = stage.offsetHeight;
      pinTop = Math.max(72, Math.round((vh - stageH) / 2));
      sec.style.setProperty("--jxh-pin-top", pinTop + "px");
      sec.style.height = (stageH + Math.round(vh * (lines.length * 0.2 + 0.1))) + "px";
    }

    function paint() {
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var dist = Math.max(1, r.height - stageH);
      // Start as the words come up the screen, so the first line is already on its way.
      var lead = Math.max(0, vh * 0.85 - pinTop);
      var p = Math.min(1, Math.max(0, (pinTop + lead - r.top) / (dist + lead)));
      // If sticky positioning is blocked by the theme, hold the stage in place by hand.
      if (fallback) {
        stage.style.transform = "translateY(" + Math.min(Math.max(pinTop - r.top, 0), dist) + "px)";
      } else if (r.top < pinTop - 2 && r.bottom > pinTop + stageH + 2 && Math.abs(stage.getBoundingClientRect().top - pinTop) > 2) {
        fallback = true; stage.style.position = "relative"; paint(); return;
      }
      var n = inner.length, span = 0.85;
      inner.forEach(function (s, i) {
        var start = (i / n) * span, len = (span / n) * 1.6;
        var t = Math.min(1, Math.max(0, (p - start) / len));
        // Every line is faintly there from the start; each one lifts into place and turns white in turn.
        var e = 1 - Math.pow(1 - t, 3);
        s.style.transform = "translateY(" + ((1 - e) * 0.45).toFixed(3) + "em)";
        s.style.color = "rgb(246 245 240 / " + (0.14 + 0.86 * e).toFixed(3) + ")";
      });
    }

    var raf = 0;
    function onScroll() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paint(); }); }
    var lastW = window.innerWidth;
    function onResize() { if (window.innerWidth !== lastW) { lastW = window.innerWidth; build(); } else { size(); } paint(); }
    build(); paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { build(); paint(); });
    // Capture scrolls from the page or any scrolling container the theme uses.
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    window.addEventListener("resize", onResize);
  });

  // App showcase: the phone shows the screen for the step in the middle of the view.
  document.querySelectorAll("[data-showcase]").forEach(function (sec) {
    var steps = sec.querySelectorAll("[data-step]");
    var screens = sec.querySelectorAll("[data-screen]");
    function show(name) {
      screens.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-screen") === name); });
      steps.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-step") === name); });
    }
    var list = sec.querySelector(".jxh-show__steps");
    var sideways = window.matchMedia("(max-width: 899px)").matches;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) show(e.target.getAttribute("data-step")); });
    }, sideways ? { root: list, threshold: 0.6 } : { rootMargin: "-45% 0px -45% 0px" });
    steps.forEach(function (s) {
      io.observe(s);
      s.addEventListener("click", function () {
        show(s.getAttribute("data-step"));
        if (sideways) s.scrollIntoView({ behavior: reduce ? "auto" : "smooth", inline: "center", block: "nearest" });
      });
    });
  });
})();
